var map = {
	"./Article.vue": "dc20",
	"./Banner.vue": "8f17",
	"./Button.vue": "90cd",
	"./CTA.vue": "aec2",
	"./Checkbox.vue": "d627",
	"./Content.vue": "1f33",
	"./Extra.vue": "a709",
	"./Feature.vue": "7805",
	"./Logos.vue": "e648",
	"./More.vue": "a7cc",
	"./Panel.vue": "e87c",
	"./Profile.vue": "61d4",
	"./Quotes.vue": "a7d6",
	"./Selectbox.vue": "6dcb",
	"./Service.vue": "cfa6",
	"./Submenu.vue": "8b1e",
	"./Tag.vue": "5ea5",
	"./Text.vue": "abfd",
	"./Textbox.vue": "7c39",
	"./Wrapper.vue": "2814"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "b71f";